<template>
  <div class="coordinate-module">
    <Actions :guidesVisible="guidesVisible" />

    <div class="coordinate-wrapper">
      <Terms v-for="(term, index) in terms" :key="index" :type="index" :term="term" />

      <TokenGuide
        v-for="(item, index) in originalParties"
        :key="index"
        :token="item"
        :guidesVisible="guidesVisible"
      />

      <span class="circle circle-01"></span>
      <span class="circle circle-02"></span>
      <span class="circle circle-03"></span>
      <span class="circle circle-04"></span>

      <div class="label links">Links</div>
      <div class="label rechts">Rechts</div>
      <div class="label conservatief">Conservatief</div>
      <div class="label progressief">Progressief</div>
    </div>

    <div class="source">bron Kieskompas</div>
  </div>
</template>

<script>
  import TokenGuide from "./TokenGuide.vue";
  import Actions from "./Actions.vue";
  import Terms from "./Terms.vue";

  export default {
    name: "Coordinates",
    components: {
      TokenGuide,
      Actions,
      Terms,
    },

    props: {
      parties: {
        type: Object,
        default: () => {},
      },
      guidesVisible: Boolean,
      terms: {
        type: Object,
        default: () => {},
      },
    },

    computed: {
      // exclude newly added parties
      originalParties() {
        return this.parties.filter(function (partie) {
          return !partie.removable;
        });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .coordinate-module {
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .coordinate-wrapper {
      width: 45%;
      padding-bottom: 45%;
      border: 1px dashed rgba(0, 0, 0, 0.2);
      border-radius: 100%;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        width: 2px;
        height: 104%;
        background-color: $cerulean;
        top: -2%;
        left: 50%;
        margin-left: -1px;
      }

      &:before {
        content: "";
        position: absolute;
        width: 105%;
        height: 2px;
        background-color: $cerulean;
        top: 50%;
        left: -2%;
        margin-top: -1px;
      }
    }

    .label {
      position: absolute;
      font-weight: $font-medium;
      color: $cerulean;
      text-transform: uppercase;
      line-height: 0;
    }

    .links {
      top: 50%;
      left: 0;
      margin-left: -7em;
    }

    .rechts {
      top: 50%;
      right: 0;
      margin-right: -7em;
    }

    .conservatief {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: -60px;
    }

    .progressief {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      margin-top: -60px;
    }

    .circle {
      border: 1px dashed rgba(0, 0, 0, 0.2);
      position: absolute;
      border-radius: 100%;
      pointer-events: none;

      &.circle-01 {
        width: 80%;
        height: 80%;
        left: 10%;
        top: 10%;
      }

      &.circle-02 {
        width: 60%;
        height: 60%;
        left: 20%;
        top: 20%;
      }

      &.circle-03 {
        width: 40%;
        height: 40%;
        left: 30%;
        top: 30%;
      }

      &.circle-04 {
        width: 20%;
        height: 20%;
        left: 40%;
        top: 40%;
      }
    }

    .source {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 20px;
      color: rgba(0, 0, 0, 0.3);
      text-transform: uppercase;
      margin: 0 15px;
      font-size: 14px;
      line-height: 1.8em;
      font-weight: $font-medium;
    }
  }
</style>
